export const LoanContractAddress = "0x60Ca4F48A71399397ddB5B688e99feC4dc468f83";
export const ProductNFTContractAddress =
  "0x440F8115c618C8C7EEd89c51455cDeD3AD17c28d";
